import dayjs, { Dayjs } from 'dayjs';

import { FeftchSpan, store } from './store';

/**========================================================================
 *                           Filter
 *========================================================================**/
export const setTsFilterRange = (tsFilterRange: [number, number]) => {
  store.tsFilterRange = tsFilterRange;
};

export const setReeferId = (reeferId: string) => {
  store.reeferId = reeferId;
};

export const setIsLoading = (isLoading: boolean) => {
  store.isLoading = isLoading;
};

export const setInitialFetch = (initialFetch: boolean) => {
  store.initialFetch = initialFetch;
};

/**========================================================================
 *                           Fetch filter
 *========================================================================**/
export const calculateEndDate = (
  range: FeftchSpan,
  startDate: Dayjs,
): Dayjs => {
  let date = dayjs(startDate); // Créer une nouvelle instance de Dayjs à partir de startDate
  switch (range) {
    case FeftchSpan.WEEK:
      date = date.add(7, 'day'); // Ajouter 7 jours
      break;
    case FeftchSpan.MONTH:
      date = date.add(1, 'month'); // Ajouter 1 mois
      break;
    case FeftchSpan.MONTH_3:
      date = date.add(3, 'month'); // Ajouter 3 mois
      break;
    case FeftchSpan.MONTH_6:
      date = date.add(6, 'month'); // Ajouter 6 mois
      break;
    default:
      break;
  }
  return date;
};

export const setFetchLimits = (fetchLimits: [Dayjs, Dayjs]) => {
  // Il n'est appelé qu'une seule fois lors de l'initialisation de la page
  store.fetchLimits = fetchLimits;
  const defaultEndFetchRange = calculateEndDate(
    store.fetchSpan,
    fetchLimits[0],
  );
  store.tsFetchRange = [
    fetchLimits[0].valueOf(),
    defaultEndFetchRange.valueOf(),
  ];
};

export const setTsFetchRange = (tsFetchRange: [number, number]) => {
  store.tsFetchRange = tsFetchRange;
};

export const setFetchStart = (startDate: Dayjs) => {
  const newEndFetchRange = calculateEndDate(store.fetchSpan, startDate);
  store.tsFetchRange = [startDate.valueOf(), newEndFetchRange.valueOf()];
};

export const setFetchSpan = (fetchSpan: FeftchSpan) => {
  if (!store.tsFetchRange) return;
  const newEndFetchRange = calculateEndDate(
    fetchSpan,
    dayjs(store.tsFetchRange[0]),
  );
  store.fetchSpan = fetchSpan;
  store.tsFetchRange = [store.tsFetchRange[0], newEndFetchRange.valueOf()];
};
